export default __webpack_public_path__ + "static/media/login03.938c5d84.jpg";